// extracted by mini-css-extract-plugin
export default {"gif":"HeaderGif_gif__przd+"};